<rx-upload-zone (droppedFiles)="uploadFile($event)" [imageSize]="{ width: 400, height: 300 }">
  <div class="upload-content-wp">
    <rx-icon name="arr-upload" size="45"></rx-icon>
    <p class="upload-info">
      Drag your {{ data?.payload?.fileType }} file here or
      <span rxUpload (uploadedFiles)="uploadFile($event)" [imageSize]="{ width: 400, height: 300 }" multiple="true"
        >upload</span
      >
      it from your device
    </p>
    <!--        <p class="alert-info" [ngClass]="{'error': !isImgSizeValid }"> Custom thumbnail should not be larger than 400*300 pixels</p>-->
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
  </div>
</rx-upload-zone>
